import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fly",
  "use": "fly-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 16 12\" id=\"fly\"><path d=\"M15.84.007.249 5.647a.377.377 0 0 0-.085.665l2.331 1.592 10.577-5.583-8.954 6.692v2.711c0 .184.207.296.362.194l1.972-1.309 1.943 1.326a.38.38 0 0 0 .535-.115L15.981.182c.059-.096-.036-.214-.141-.175Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol